export const drawerStyle = {
  width: '250px',
  bgcolor: 'background.paper',
  '& .MuiListItemButton-root:hover': {
    color: '#ff008c',
    '&:hover': {
      '& .MuiListItemIcon-root': {
        color: '#ff008c',
      },
      '& .MuiListItemText-root': {
        '& a': {
          color: '#ff008c',
        },
      },
    },
  },
  '& .MuiListItemIcon-root': {
    color: '#000000',
  },
  '& .MuiListItemText-root': {
    '& a': {
      color: '#000000',
      textDecoration: 'none',
    },
  },
};
